module.exports = __webpack_public_path__ + "images/for_company_page/dream_gate_bd5453cc1110e0f9c34c3cdc1703d4c9.gif";